import { gql } from '@apollo/client';

export default gql`
  fragment TaxTransactionSyncInfo on TaxTransactionSync {
    id
    state
    transactionKind
    transactionId
    transactionReferenceId
    subjectId
    subjectType
    correlationId
    reportableAt
    attemptCount
    attemptCycleCount
    manualReplayCount
    lastAttemptAt
    nextAttemptAt
    synchronizedAt
    lastProviderStatus
    lastErrorCode
    lastErrorMessage
    providerResponse
  }
`;
